import classnames from 'classnames/bind'
import Image from '@/components/common/Image'
import { isEmpty } from 'lodash-es'
import { useAppSelector } from '@/redux/hooks'

// Libs

// Components
import Link from '@/components/common/Link'
import LanguageSelector from '@/components/shared/LanguageSelector'
import Icon from '@/assets/icons'

// Constants
import { EXTERNAL_LINK } from '@/constants/externalLink'

// Styles
import styles from './style.module.scss'

// Variables
const cx = classnames.bind(styles)

const languageList = [
  {
    label: '繁體中文',
    value: 'zh-tw',
  },
  {
    label: 'English',
    value: 'en-us',
  },
]

function SimpleHeader() {
  const memberData = useAppSelector((state) => state?.member?.memberData)

  const handleHumanIconClick = () => {
    window.open('https://winnerpickleball.com/quienes-somos')
  }

  return (
    <header className={cx('header')}>
      <div className={cx('header__wrapper')}>
        <Link url={EXTERNAL_LINK.WINNER_PICKLE_BALL_OFFICIAL_SITE} isOpen>
          <div className={cx('header-logo')}>
            <Image src={`/images/winnerpickleball-logo.png`} width={200} height={63} alt={'Winner Pickle Ball'} />
          </div>
        </Link>
        <div className={cx('header__right')}>
          {!isEmpty(memberData.refCode) && <div className={cx('header__code')}>ID: {memberData.refCode}</div>}
          <LanguageSelector iconColor='white' textColor='white' languageList={languageList} />
          <button onClick={handleHumanIconClick} className={cx('header__icon')}>
            <Icon.Human />
          </button>
        </div>
      </div>
    </header>
  )
}

export default SimpleHeader
